// extracted by mini-css-extract-plugin
export var carrierIcon = "_tl-0";
export var carrierLogo = "_tl-1";
export var detailsSection = "_tl-2";